"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const react_visibility_sensor_1 = __importDefault(require("react-visibility-sensor"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_text_multiline_ellipsis_1 = require("@hotelplan/components.common.text-multiline-ellipsis");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const TripAdvisorRaiting_1 = __importDefault(require("./TripAdvisorRaiting"));
const ShowMoreLessButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    variant: 'linkBtn',
})(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(theme.tripAdvisor.moreLessButton));
const TAReviewCommentWrap = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    width: ['100%', `${(7 / 10) * 100}%`],
}));
const TACommentTitle = styled_components_1.default.h3(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(theme.tripAdvisor.commentTitle));
const TACommentContent = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    mb: [1, 3],
}));
const TACommentText = (0, styled_components_1.default)(components_common_text_multiline_ellipsis_1.TextMultilineEllipsis)(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(theme.tripAdvisor.commentText));
const TripAdvisorReviewComment = ({ title, text, subRatings, className, }) => {
    const [t] = (0, next_i18next_1.useTranslation)();
    const [isMore, , , toggleMore] = (0, libs_hooks_react_1.useToggleState)(false);
    const [isClamped, setIsClamped] = (0, react_1.useState)(false);
    const [isVisible, setIsVisible] = (0, react_1.useState)(false);
    const commentRef = (0, react_1.useRef)(null);
    const handleShowMoreLess = () => {
        if (!isVisible && isMore && commentRef.current) {
            commentRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
        toggleMore();
    };
    const handleTextReflow = (0, react_1.useCallback)(({ clamped }) => {
        setIsClamped(clamped);
    }, []);
    return (react_1.default.createElement(react_visibility_sensor_1.default, { onChange: setIsVisible, intervalCheck: true },
        react_1.default.createElement(TAReviewCommentWrap, { className: `${className ? className : ''} review-comment`, ref: commentRef },
            react_1.default.createElement(TACommentTitle, null, title),
            react_1.default.createElement(TACommentContent, null,
                react_1.default.createElement(TACommentText, { maxLines: 6, onReflow: handleTextReflow, isOpen: isMore }, text),
                isMore &&
                    subRatings.map(({ rating: reviewRating, name: reviewName }, i) => {
                        return (react_1.default.createElement(TripAdvisorRaiting_1.default, { key: i, rating: reviewRating, label: reviewName }));
                    })),
            isClamped && (react_1.default.createElement(ShowMoreLessButton, { onClick: handleShowMoreLess }, isMore ? t('showLess') : t('showMore'))))));
};
exports.default = TripAdvisorReviewComment;
//# sourceMappingURL=TripAdvisorReviewComment.js.map